define('score_bootstrap/Models/Search/SearchRequest',["jquery", "score_bootstrap/Utils/UrlHelper"], function ($, urlHelper) {
    "use strict";

    // maps to Score.BootstrapUI.Web.Areas.ScoreBootstrapUI.Models.ContentSearch.SearchApiComponent
    var searchApiComponentEnum = ["SearchResults", "SuggestionSection"];

    function getFirstActiveFacet(facet) {
        return facet.values.find(function(value) {
            return value.selected;
        });
    }

    function SearchRequest(selectedFacets, selectedRangeFacets, selectedRatingsFacets) {

        var urlQueryParam = "q",
            queryInUrl = urlHelper.getUrlParameters(window.location, urlQueryParam),
            instance = {
                startPage : 0,
                page: 0,
                perPage: 9,
                query: queryInUrl.length ? queryInUrl[0] : "",
                root: "",
                indexName: "",
                facets: Array.isArray(selectedFacets) ? selectedFacets : [],
                rangeFacets: Array.isArray(selectedRangeFacets) ? selectedRangeFacets : [],
                ratingsFacets: Array.isArray(selectedRatingsFacets) ? selectedRatingsFacets : [],
                templates: [],
                language: "en",
                tileNames: [],
                component: 0,
                customData: {}
            };

        Object.defineProperties(this, {
            startPage: {
                enumerable: true,
                get: function () { return instance.startPage; },
                set: function (value) {
                    var valueAsInt = parseInt(value, 10);
                    if (!isNaN(valueAsInt)) {
                        instance.startPage = valueAsInt;
                    }
                }
            },
            page: {
                enumerable: true,
                get: function () { return instance.page; },
                set: function (value) {
                    var valueAsInt = parseInt(value, 10);
                    if (!isNaN(valueAsInt)) {
                        instance.page = valueAsInt;
                    }
                }
            },
            perPage: {
                enumerable: true,
                get: function () {
                    return instance.perPage;
                },
                set: function (value) {
                    var valueAsInt = parseInt(value, 10);
                    if (!isNaN(valueAsInt) && valueAsInt > 0) {
                        instance.perPage = valueAsInt;
                    }
                }
            },
            query: {
                enumerable: true,
                get: function () {
                    var query = urlHelper.getUrlParameters(window.location, urlQueryParam);
                    return query.length ? query[0] : "";
                },
                set: function (value) {
                    urlHelper.setUrlParameters(window.location, urlQueryParam, String(value || ""));
                }
            },
            root: {
                enumerable: true,
                get: function () {
                    return instance.root;
                },
                set: function (value) {
                    instance.root = String(value);
                }
            },
            indexName: {
                enumerable: true,
                get: function () {
                    return instance.indexName;
                },
                set: function (value) {
                    instance.indexName = String(value);
                }
            },
            facets: {
                enumerable: true,
                get: function () {
                    return instance.facets;
                },
                set: function (value) {
                    if (Array.isArray(value)) {
                        instance.facets = value.slice();
                    }
                }
            },
            rangeFacets: {
                enumerable: true,
                get: function () {
                    return instance.rangeFacets;
                },
                set: function (value) {
                    if (Array.isArray(value)) {
                        instance.rangeFacets = value.slice();
                    }
                }
            },
            ratingsFacets: {
                enumerable: true,
                get: function () {
                    return instance.ratingsFacets;
                },
                set: function (value) {
                    if (Array.isArray(value)) {
                        instance.ratingsFacets = value.slice();
                    }
                }
            },
            templates: {
                enumerable: true,
                get: function () {
                    return instance.templates;
                },
                set: function (value) {
                    if (Array.isArray(value)) {
                        instance.templates = value.slice();
                    }
                }
            },
            language: {
                enumerable: true,
                get: function () { return instance.language; },
                set: function (value) {
                    if (value) {
                        instance.language = String(value);
                    }
                }
            },
            tileNames: {
                enumerable: true,
                get: function () {
                    return instance.tileNames;
                },
                set: function (value) {
                    instance.tileNames = value.slice(0);
                }
            },
            component: {
                enumerable: true,
                get: function () {
                    return instance.component;
                },
                set: function (value) {
                    instance.component = searchApiComponentEnum.indexOf(value);
                }
            },
            customData: {
                enumerable: true,
                get: function () {
                    return instance.customData;
                },
                set: function (value) {
                    instance.customData = value;
                }
            },
            firstActiveFacet: {
                enumerable: false,
                get: function () {
                    return instance.facets.length ? instance.facets.find(getFirstActiveFacet) : null;
                }
            }
        });

        this.addTileRequest = function addTileRequest(tileName) {
            if (tileName && typeof (tileName) === "string")
                instance.tileNames.push(tileName);
        };
    }

    return SearchRequest;
});
